import React, { Component, useEffect, useReducer, useRef } from "react";
import DataForm from "./../../../components/DataForm/DataForm";
import axios from "../../../axios";
import { Alert, Services } from "../../Service/Services";
import Dropdown from "../../../components/Dropdown/Dropdown";
import BoxContainer from "../../../components/BoxContainer/BoxContainer";
import { CheckInAPI } from "../../../api";
import { useParams, useHistory } from "react-router-dom";
import MemberType from "./MemberType";
import moment from "moment";
import LOV from "../../../components/LOV/LOV";
const $ = window.$;
const _ = require("lodash");

const initState = {
  data: {
    id: "",
    code: "",
    identity_number: "",
    prefix: "",
    first_name: "",
    last_name: "",
    career: "",
    career_number: "",
    nurse_number: "",
    telephone: "",
    company_name: "",
    register_date: "",
    type: "",
    first_update: true,
  },
  datasource: {
    prefix_name: [],
    career: [],
  },
  loading: true,
};

const ACTION = {
  RETRIEVE: "retrieve",
  SET_LOADING: "set_loading",
  CLEAR: "clear",
  UPDATE_VALUE: "update_value",
  SET_DATASOURCE: "set_datasource",
  SET_ERRORS: "set_errors",
  SET_RETRIEVE_ERRORS: "set_retrieve_errors",
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION.RETRIEVE:
      return {
        ...state,
        data: action.payload,
        loading: false,
        errors: [],
      };
    case ACTION.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case ACTION.UPDATE_VALUE:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      };

    case ACTION.SET_DATASOURCE:
      return {
        ...state,
        datasource: { ...state.datasource, ...action.payload },
        loading: false,
      };

    case ACTION.SET_ERRORS:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };
    case ACTION.SET_RETRIEVE_ERRORS:
      return {
        ...state,
        errors: action.payload,
        loading: false,
        data: {
          ...initState.data,
        },
      };

    case ACTION.CLEAR:
      return {
        ...state,
        loading: false,
        data: initState.data,
        errors: [],
      };

    default:
      return state;
  }
};

const OfflineCheckInForm = () => {
  const [state, dispatch] = useReducer(reducer, initState);
  const inputCodeRef = useRef(null);
  const { code } = useParams();
  const history = useHistory();

  const getAPIDatasource = () => {
    const api_url = "datasource";
    const params = {
      tables: [{ name: "career" }, { name: "prefix_name" }],
    };

    const promise = axios
      .post(api_url, params)
      .then((res) => {
        const datasource = {
          career: res.data.career.map((item) => {
            return { key: item.id, label: item.name, code: item.code };
          }),
          prefix_name: res.data.prefix_name.map((item) => {
            return { key: item.id, label: item.name };
          }),
        };

        return datasource;
      })
      .catch((res) => {});

    return promise;
  };

  useEffect(() => {
    window.setTimeout(() => {
      const inputCode = inputCodeRef.current;
      inputCode.focus();

      var debounced = _.debounce((e) => {
        retrieveData(e.target.value);
      }, 1000);

      $(inputCode).off("keyup").on("keyup", debounced);
    }, 0);

    getAPIDatasource().then((datasource) => {
      dispatch({ type: ACTION.SET_DATASOURCE, payload: datasource });

      if (code) {
        inputCodeRef.current.value = code;
        retrieveData(code);
      }
    });
  }, []);

  const retrieveData = (code) => {
    if (code) {
      dispatch({ type: ACTION.SET_LOADING, payload: true });
      CheckInAPI.getMember(code.trim())
        .then((data) => {
          dispatch({ type: ACTION.RETRIEVE, payload: data });
        })
        .catch((res) => {
          const errors = res.data.errors;
          dispatch({ type: ACTION.SET_RETRIEVE_ERRORS, payload: errors });
        });
    }
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    const target = { [name]: value };
    dispatch({ type: ACTION.UPDATE_VALUE, payload: target });
  };

  const saveData = () => {
    dispatch({ type: ACTION.SET_LOADING, payload: true });
    const params = state.data;
    CheckInAPI.saveMember(params, state.data.id)
      .then(() => {
        Alert.done("บันทึกข้อมูลเรียบร้อย").then(() => {
          dispatch({ type: ACTION.CLEAR });
          inputCodeRef.current.value = "";
          inputCodeRef.current.focus();
        });
      })
      .catch((errors) => {
        dispatch({ type: ACTION.SET_ERRORS, payload: errors });
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    Alert.confirm("คุณแน่ใจไหมที่จะบันทึกข้อมูล").then((res) => {
      if (res === true) saveData();
    });
  };

  const clearField = (e) => {
    e.preventDefault();

    dispatch({ type: ACTION.CLEAR });
    inputCodeRef.current.value = "";
  };

  const changeMember = (e) => {
    e.preventDefault();
    if (state.data.code == "") return Alert.error("กรุณากรอกรหัสผู้ใช้");
    if (state.data.first_update == false)
      return Alert.error("ไม่สามารถเปลี่ยนคนมาแทนซ้ำได้");

    history.push(`/offline/checkin/replace/${state.data.code}`);
  };

  const onPrintClick = (e) => {
    e.preventDefault();
    let print_url;
    const baseURL = axios.defaults.baseURL;

    switch (state.data.type) {
      case "keynote":
        print_url = "keynoteprintcard";
        break;

      case "guest":
        print_url = "guestprintcard";
        break;

      case "member":
        print_url = "memberprintcardsingle";
        break;
    }

    if (print_url)
      window.open(`${baseURL}/${print_url}/${state.data.id}`, "_blank");
  };

  let buttons = (
    <>
      <button
        type="submit"
        disabled={!state.data.id}
        className="btn btn-primary btn-block btn-lg"
        style={{ fontSize: "3em" }}
      >
        <i className="fa fa-floppy-o"></i> บันทึก
      </button>
      <button
        onClick={clearField}
        className="btn btn-warning btn-block btn-lg"
        style={{ fontSize: "3em" }}
      >
        <i className="fa fa-paint-brush"></i> ล้างข้อมูล
      </button>
      <button
        disabled={!state.data.code || state.data.first_update === false}
        onClick={changeMember}
        className="btn btn-info btn-block btn-lg"
        style={{ fontSize: "3em" }}
      >
        {state.data.first_update === true ? (
          <>
            <i className="fa fa-user"></i> เปลี่ยนคนมาแทน
          </>
        ) : (
          <>
            <i className="fa fa-ban"></i> ไม่สามารถเปลี่ยนคนมาแทนได้
          </>
        )}
      </button>
      <button
        disabled={!state.data.code}
        onClick={onPrintClick}
        className="btn btn-danger btn-block btn-lg"
        style={{ fontSize: "3em" }}
      >
        <i className="fa fa-id-card-o"></i> พิมพ์บัตรเข้าร่วมงาน
      </button>
    </>
  );

  const telephone = state.data.telephone;
  const company_name = state.data.company_name;
  const register_date = state.data.register_date;

  return (
    <BoxContainer loading={state.loading} errors={state.errors}>
      <DataForm allow_save={false} onSubmit={onSubmit} hideSeperateLine={true}>
        <div>
          <div className="alert alert-primary">
            <h2>
              <i className="fa fa-info-circle"></i> ลงทะเบียนเข้าร่วมงาน{" "}
              <MemberType value={state.data.type} />
            </h2>
          </div>
          <div className="d-flex mb-1 h3">
            <label htmlFor="code" className="pr-2 field-required">
              รหัสผู้ใช้:
            </label>
            <input
              type="text"
              className="flex-fill"
              id="code"
              name="code"
              ref={inputCodeRef}
              required={true}
            ></input>
            <LOV
              columns={[
                { label: "รหัสบัตร", name: "id", className: ["text-center"] },
                { label: "ชื่อ นามสกุล", name: "name" },
              ]}
              name="member"
              title="Members"
              api={{
                url: "/lov/paidmember",
              }}
              is_button={true}
              button_text=""
              onChange={(value) => {
                const inputCode = inputCodeRef.current;
                inputCode.value = value.key;
                inputCode.focus();

                retrieveData(inputCode.value);
              }}
            />
          </div>
          <div className="d-flex mb-1 h3">
            <label htmlFor="identity_number" className="pr-2 field-required">
              เลขที่บัตรประชาชน:
            </label>
            <input
              type="text"
              className="flex-fill"
              id="identity_number"
              name="identity_number"
              onChange={onChange}
              value={state.data.identity_number}
              required={true}
              maxLength={13}
            ></input>
          </div>
          <div className="d-flex mb-1 h3">
            <label htmlFor="prefix" className="pr-2 field-required">
              คำนำหน้าชื่อ:
            </label>
            <div className="flex-fill">
              <Dropdown
                datasource={state.datasource.prefix_name}
                name="prefix"
                value={state.data.prefix}
                onChange={onChange}
                allow_new_item={true}
                required={true}
                placeholder="กรุณาเลือก"
              ></Dropdown>
            </div>
          </div>
          <div className="d-flex mb-1 h3">
            <label htmlFor="first_name" className="pr-2 field-required">
              ชื่อ:
            </label>
            <input
              type="text"
              className="flex-fill"
              id="first_name"
              name="first_name"
              onChange={onChange}
              value={state.data.first_name}
              required={true}
            ></input>
          </div>
          <div className="d-flex mb-1 h3">
            <label htmlFor="last_name" className="pr-2 field-required">
              นามสกุล:
            </label>
            <input
              type="text"
              className="flex-fill"
              id="last_name"
              name="last_name"
              onChange={onChange}
              value={state.data.last_name}
              required={true}
            ></input>
          </div>
          <div className="d-flex mb-1 h3">
            <label htmlFor="career" className="pr-2">
              วิชาชีพ:
            </label>
            <div className="flex-fill">
              <Dropdown
                datasource={state.datasource.career}
                name="career"
                value={state.data.career}
                onChange={onChange}
                allow_new_item={true}
                placeholder="กรุณาเลือก"
              ></Dropdown>
            </div>
          </div>
          <div className="d-flex mb-1 h3">
            <label htmlFor="career_number" className="pr-2">
              เลขที่ประกอบวิชาชีพ:
            </label>
            <input
              type="text"
              className="flex-fill"
              id="career_number"
              name="career_number"
              onChange={onChange}
              value={state.data.career_number}
            ></input>
          </div>
          <div className="d-flex mb-1 h3">
            <label htmlFor="nurse_number" className="pr-2">
              เลขที่สมาชิกสภาการพยาบาล:
            </label>
            <input
              type="text"
              className="flex-fill"
              id="nurse_number"
              name="nurse_number"
              onChange={onChange}
              value={state.data.nurse_number}
            ></input>
          </div>
          <div className="d-flex mb-1 h3">
            <label className="pr-2">เบอร์โทรศัพท์:</label>
            <span>{telephone}</span>
          </div>
          <div className="d-flex mb-1 h3">
            <label className="pr-2">ชื่อโรงพยาบาล:</label>
            <span>{company_name}</span>
          </div>
          <div className="d-flex mb-1 h3">
            <label className="pr-2">วันเวลาที่ลงทะเบียน:</label>
            <span>
              {register_date
                ? moment(register_date).format("MMMM Do YYYY, h:mm:ss")
                : ""}
            </span>
          </div>
          {buttons}
        </div>
      </DataForm>
    </BoxContainer>
  );
};

export default OfflineCheckInForm;
